import { useState } from "react";
import { Link, useNavigate, redirect } from "react-router-dom";
import styles from "./login-page.module.css";
import authService, { AuthUserDto } from "../../services/authService";
import Button from "../../components/controls/Button/Button";

export interface LoginPageProps {}

export const LoginPage = (props: LoginPageProps) => {
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isBusy, setIsBusy] = useState(false);

  const navigate = useNavigate();
  const LOGIN_FAILED_MESSAGE = "Invalid Username or Password!";

  function handleLoginButtonClick() {
    debugger;
    // Authenticate the user.
    // if user is authenticated then redirect to app

    const loginUser = async () => {
      console.log(userName, password);

      setIsBusy(true);
      const res = await authService.login(userName, password);
      if (!res) {
        setLoginErrorMessage(LOGIN_FAILED_MESSAGE);
        setIsBusy(false);
        return;
      }

      if (res.status && res.data) {
        const user: AuthUserDto = res.data.user;
        if (user !== undefined && res.data.token !== undefined) {
          authService.saveUserLoginAuth(res.data.user, res.data.token);
          setIsBusy(false);
          //redirect("/app");
          navigate("/", {
            replace: true,
          });
        } else {
          setLoginErrorMessage(LOGIN_FAILED_MESSAGE);
          setIsBusy(false);
          return;
        }
      } else {
        alert("Unable to login at this time. Please try again!");
        setIsBusy(false);
      }
    };

    loginUser();
  }

  function clearLoginErrorMessage() {
    if (loginErrorMessage !== "") {
      setLoginErrorMessage("");
    }
  }

  return (
    <div className={styles.loginPage}>
      <div>
        <div className={styles.loginForm}>
          <h3>Login</h3>
          <p>Sign in to manage your business.</p>
          {/* <div className="row">
            <div className="col col-md-2">
              <img src="../coopman-icon.png" alt="coopman_logo" height={50} />
            </div>
            <div className="col col-md-10">
              <h3>Login</h3>
              <p>Sign in to manage your business.</p>
            </div>
          </div> */}

          <hr />
          <div className="form-field">
            <label htmlFor="userName" className={styles.controlLabel}>
              Login ID <span>*</span>
            </label>
            <input
              onBlur={(e) => setUserName(e.target.value)}
              onChange={clearLoginErrorMessage}
              className="form-control"
              placeholder="Enter your login ID"
              type="text"
              name="userName"
              id="userName"
              required
            />
          </div>
          <div className="form-field">
            <label htmlFor="password" className={styles.controlLabel}>
              Password <span>*</span>
            </label>
            <input
              onBlur={(e) => setPassword(e.target.value)}
              onChange={clearLoginErrorMessage}
              className="form-control"
              title="Password"
              placeholder="Enter your password"
              type="password"
              name="password"
              id="password"
              required
            />
          </div>
          <p>
            <Link to="/forgot-password">Forgot your password?</Link>
          </p>
          <div className={styles.loginButtonContainer}>
            <Button
              text="Sign In"
              onClick={handleLoginButtonClick}
              id="btnLogin"
              cssClass="btn btn-primary w-100"
              isBusy={isBusy}
            />
          </div>
          <div>
            {(loginErrorMessage !== "" || loginErrorMessage.length >= 1) && (
              <span className={styles.error}>{loginErrorMessage}</span>
            )}
          </div>
          <p>
            Don't have an account? <Link to="/registration">Register Now</Link>{" "}
          </p>
        </div>
        <p>
          Copyright @Mamre Technologies Ltd, {new Date().getFullYear()} |{" "}
          <Link to="/privacy">Privacy</Link>
        </p>
      </div>
    </div>
  );
};
